import Reveal from "@/components/base/Reveal";
import { featureCards } from "@/mocks/home";

export default function FeatureFlow() {
  const [lead, ...rest] = featureCards;

  return (
    <section id="featured" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-medium tracking-[0.24em] text-primary-600">
                FEATURED STORY
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                今日热点主线
              </h2>
            </div>
            <p className="max-w-xl text-sm leading-relaxed text-secondary-600">
              每条主线都附上原始材料入口与核对结论，封面即线索，点开就能顺着往下扒。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-12">
          {/* 头条大图卡 */}
          <Reveal as="article" className="lg:col-span-7">
            <a
              href="#timeline"
              className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="h-56 w-full overflow-hidden md:h-80">
                <img
                  src={lead.image}
                  alt={lead.title}
                  title={`${lead.title} 黑料曝光`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
              <div className="flex flex-1 flex-col p-5 md:p-6">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                    {lead.tag}
                  </span>
                  <span className="text-xs text-secondary-500">{lead.time}</span>
                </div>
                <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  {lead.title}
                </h3>
                <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-secondary-600">
                  {lead.excerpt}
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-4 border-t border-background-200 pt-4 text-xs text-secondary-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-fire-line text-primary-500" />
                    {lead.heat}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-timer-line" />
                    阅读 {lead.read}
                  </span>
                  <span className="ml-auto flex items-center gap-1 whitespace-nowrap font-medium text-primary-600">
                    查看时间线
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          </Reveal>

          {/* 右侧卡流 */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-5 lg:grid-cols-1">
            {rest.map((card, index) => (
              <Reveal key={card.id} as="article" delay={80 * (index + 1)}>
                <a
                  href="#evidence"
                  className="group flex h-full gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-100 p-3 transition-colors hover:border-primary-300"
                >
                  <div className="h-24 w-28 shrink-0 overflow-hidden rounded-md md:h-28 md:w-32">
                    <img
                      src={card.image}
                      alt={card.title}
                      title={`${card.title} 黑料曝光`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                    />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col">
                    <div className="flex items-center gap-2">
                      <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800">
                        {card.tag}
                      </span>
                      <span className="text-[11px] text-secondary-500">
                        {card.time}
                      </span>
                    </div>
                    <h3 className="mt-2 line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 md:text-base">
                      {card.title}
                    </h3>
                    <div className="mt-auto flex items-center gap-3 pt-2 text-[11px] text-secondary-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line text-primary-500" />
                        {card.heat}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-timer-line" />
                        {card.read}
                      </span>
                    </div>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}